module.exports = __webpack_public_path__ + "media/src/img/logo-ru_new_year-504730703a43ef988b79e3e5ac4f988e.png";